import { useMutation, useQueryClient } from '@tanstack/react-query';
import useSelectedEnv from '@elementary/common-ui/hooks/useSelectedEnv';
import { CLOUD_TEST_FEEDBACKS } from '@elementary/common-ui/constants/queryKeys';
import * as api from 'shared/services/api';

const useDeleteFeedback = () => {
  const selectedEnvId = useSelectedEnv();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (feedbackId: string) =>
      api.deleteCloudTestFeedbacks(selectedEnvId!, [feedbackId]),
    onSettled: () =>
      queryClient.invalidateQueries({ queryKey: [CLOUD_TEST_FEEDBACKS] }),
  });
};

export default useDeleteFeedback;
